<template>
    <div class="shared-info-message flex items-center rounded-md p-5">
        <slot name="icon">
            <IconInfo
                class="icon-extra-small"
                custom-color="#fff"
            />
        </slot>
        <slot />
    </div>
</template>

<script setup lang="ts">
    import IconInfo from '~/components/icons/IconInfo.vue';

    import { useAccountStore } from '~/stores/accountStore';
    const { appColor, buttonTextColor } = useAccountStore().state;
</script>

<style lang="scss" scoped>
.shared-info-message{
  background-color: v-bind(appColor);
  color: v-bind(buttonTextColor);
}
</style>
